<template>
    <div style="overflow: auto;height: 100vh;">
        <div class="content-top">本活动总奖金有限，先到先得，奖励发放完活</div>
        <div class="content-mid">
            <div class="mid-title">
                <div style="display: flex;align-items: center;"><span>活动数据</span>
                    <img class="back" src="../../assets/activityUrl/back.png" mode="scaleToFill" />
                </div>
                <div v-if="detailData.overBudget == 1" class="hint">活动已暂停，数据不再更新</div>
            </div>
            <div class="mid-card">
                <div class="mid-card-left">
                    <div class="flex-b-c">信用卡</div>
                    <div class="flex-b">
                        <img style="width: 53px;height: 38px;" src="../../assets/activityUrl/10.png"
                            mode="scaleToFill" />
                    </div>
                    <div class="flex-box">
                        <div class="ft-18">{{ reachData.creditCardUnFinish }}</div>
                        <div class="ft-12">待达标</div>
                    </div>
                    <div class="flex-box">
                        <div class="ft-18">{{ reachData.creditCardFinish }}</div>
                        <div class="ft-12">已达标</div>
                    </div>
                </div>
                <div class="mid-card-right">
                    <div class="flex-b-c">信贷</div>
                    <div class="flex-b">
                        <img style="width: 65px;height: 49px;" src="../../assets/activityUrl/credit.png"
                            mode="scaleToFill" />
                    </div>
                    <div class="flex-box">
                        <div class="ft-18">{{ reachData.creditUnFinish }}</div>
                        <div class="ft-12">待达标</div>
                    </div>
                    <div class="flex-box">
                        <div class="ft-18">{{ reachData.creditFinish }}</div>
                        <div class="ft-12">已达标</div>
                    </div>
                </div>
            </div>
            <div class="mid-time">
                <div class="time-label">申请订单有效期</div>
                <div class="time">{{ detailData.startTime }} 至 {{ detailData.endTime }}</div>
            </div>
            <div class="mid-time">
                <div class="time-label">达标截止时间</div>
                <div class="time">{{ detailData.overTime }}</div>
            </div>
            <div class="mid-time">
                <div class="time-label">参与本活动资源</div>
                <div style="width: 100%;height: 29px;"><span :class="current == 0 ? 'label-type active-type' : 'label-type'"
                        @click="currentChange(0)">信用卡</span><span
                        :class="current == 1 ? 'label-type active-type' : 'label-type'" style="margin-left: 20rpx;"
                        @click="currentChange(1)">贷款</span></div>
            </div>
            <div v-if="current == 0" class="resoure">
                <div v-for="i, index in bankList" :key="index" class="resoureBox">{{ i.resourceName }}</div>
            </div>
            <div v-if="current == 1" class="resoure">
                <div v-for="i, index in creditList" :key="index" class="resoureBox">{{ i.resourceName }}</div>
            </div>
            <div class="goApply" @click="goApply">去申请
                <img class="skip" src="../../assets/activityUrl/skip.png" />
            </div>
            <div class="mid-time">
                <div class="time-label">活动奖励情况（{{ detailData.rewardMode == 0 ? '阶段奖励累加' : '阶段奖励不累加' }}）</div>
                <div class="stage">
                    <div class="cell">阶段</div>
                    <div class="cell">信用卡张数</div>
                    <div class="cell">贷款产品数</div>
                    <div class="cell">奖励金额</div>
                    <div class="stage-box" :style="detailData.isCompliance == item.stage ? 'background: #e8f3fe' : ''"
                        v-for="item, index in ruleList" :key="index">
                        <div class="stage-cell">{{ item.stage }}</div>
                        <div class="stage-cell">{{ item.creditCardNum }}</div>
                        <div class="stage-cell">{{ item.creditNum }}</div>
                        <div class="stage-cell">{{ item.money }}</div>
                    </div>
                    <div class="stage-box">
                        <div class="stage-cell">预计发放</div>
                        <div class="stage-cell">{{ detailData.personMoney }}</div>
                    </div>
                </div>
            </div>
            <div class="remark">
                {{ detailData.rewardMode == 1 ? '奖励预计在达标截止时间后发放至奖励账户，届时请至我的钱包-账单中查看 ' : '每达标一个阶段发放对应奖励至奖励账户，可至我的钱包-账单中查看。'
                }}

            </div>
        </div>
        <!-- v-if="detailData.prize == 1" -->
        <Roulette  :activityId="activityId" :chance="chance"
            :rules="detailData ? detailData.detail : ''" @on-update="onUpdate" @on-over="onOver" />
    </div>
</template>
<script>
import Roulette from './kevy-mask/index.vue'
import {
    Toast
} from "vant";
import { getPrizeLeftNum, getDataList, queryCompleteCreditNum } from '@/api/index';

export default {
    components: {
        Roulette
    },
    data() {
        return {
            chance: 0, // 抽奖次数
            activityId: null,
            current: 0,
            pageNum: 1,
            pageSize: 10,
            detailData: {
                rewardMode: 0
            }, // 活动详情
            reachData: {},
            bankList: [],
            creditList: [],
            ruleList: [],
            stageList: [
                {
                    stage: 1
                },
                {
                    stage: 1
                },
                {
                    stage: 1
                },
            ],
            dataType: null
        };
    },
    created() {
        console.log(this.$route.query)
        this.activityId = this.$route.query.id
        this.dataType = this.$route.query.dataType
        this.getdata()
        this.standardData();
        this.getNumberDraws()
    },
    methods: {
        // 获取抽奖结果后
        onUpdate() {
            getPrizeLeftNum({
                activityId:this.activityId,
            },this.$store.getters.getToken)
            .then((res) => {
                    if (res.code == 200) {
                        console.log(res)
                        this.chance = res.data
                    } else {
                        Toast(res.msg);
                    }
                });
        },
        // 转盘动画停止后
        onOver() {

        },
        // 资源类型切换
        currentChange(index) {
            this.current = index
        },
        // 查询详情数据
        getdata() {
            // uni.showLoading({
            //     title: '加载中',
            //     mask: true
            // })
            let data = {
                id: this.activityId,
                dataType: this.dataType
            };
            getDataList(this.pageNum, this.pageSize, data,this.$store.getters.getToken).then((res) => {
                if (res.code == 200) {
                    // setTimeout(() => {
                    //     uni.hideLoading()
                    // }, 500)
                    this.detailData = res.data.rows[0] ? res.data.rows[0] : {};
                    this.creditList = res.data.rows[0].resourceList.filter(item => item.resourceType == 1);
                    this.bankList = res.data.rows[0].resourceList.filter(item => item.resourceType == 0);
                    this.ruleList = res.data.rows[0].ruleList
                    this.total = res.data.total
                } else {
                    Toast(res.msg);
                }
            });
        },
        // 获取抽奖次数
        getNumberDraws() {
            getPrizeLeftNum({
                activityId:this.activityId,
            }, this.$store.getters.getToken)
            .then((res) => {
                if (res.code == 200) {
                    console.log(res)
                    this.chance = res.data
                } else {
                    Toast(res.msg);
                }
            });
        },
        // 达标数据
        standardData() {
            queryCompleteCreditNum(this.activityId,this.$store.getters.getToken).then((res) => {
                    if (res.code == 200) {
                        this.reachData = res.data
                    } else {
                        Toast(res.msg);
                    }
                });
        },
        // 去申请
        goApply() {
            this.$router.push({ 
                path: `/activityResoure`,
                query: { 
                    activityId: this.activityId, 
                    status: this.detailData.overBudget 
                }
            })
        }
    },
}
</script>
<style lang="scss" scoped>
.content-top {
    width: 323px;
    height: 21px;
    font-size: 12px;
    font-family: PingFangSC, PingFang SC;
    font-weight: 400;
    color: #E02020;
    line-height: 17px;
    text-align: center;
    margin: 7px auto 5px;
}

.content-mid {
    padding: 21px 8px 0 8px;

    .mid-title {
        width: 100%;
        font-size: 18px;
        font-family: PingFangSC, PingFang SC;
        font-weight: 600;
        color: #333333;
        display: flex;
        align-items: center;
        justify-content: space-between;

        .back {
            margin: 10px;
            width: 6px;
            height: 10px;
            color: #333;
        }

        .hint {
            width: 159px;
            height: 18px;
            text-align: center;
            font-size: 13px;
            font-family: PingFangSC, PingFang SC;
            font-weight: 400;
            color: #fff;
            background: #E02020;
            border-radius: 2px;
        }
    }

    .mid-card {
        display: flex;

        .ft-12 {
            width: 100%;
            display: flex;
            align-items: center;
            justify-content: center;
            font-size: 12px;
        }

        .ft-18 {
            display: flex;
            align-items: center;
            width: 100%;
            font-family: PingFangSC, PingFang SC;
            font-weight: 600;
            justify-content: center;
            font-size: 18px;
        }

        .flex-box {
            width: 50%;
            display: flex;
            flex-wrap: wrap;
        }

        .mid-card-left {
            width: 50%;
            height: 119px;
            display: flex;
            flex-wrap: wrap;

            .flex-b {
                width: 50%;
                height: 50%;
                text-align: center;
                display: flex;
                justify-content: center;
                align-items: flex-end;
            }

            .flex-b-c {
                transform: translateY(8%);
                width: 50%;
                height: 50%;
                text-align: center;
                display: flex;
                font-size: 16px;
                font-family: PingFangSC, PingFang SC;
                font-weight: 500;
                color: #333333;
                justify-content: center;
                align-items: center;
            }
        }

        .mid-card-right {
            width: 50%;
            height: 119px;
            display: flex;
            flex-wrap: wrap;

            .flex-b {
                width: 50%;
                height: 50%;
                text-align: center;
                display: flex;
                justify-content: center;
                align-items: flex-end;
            }

            .flex-b-c {
                transform: translateY(8%);
                width: 50%;
                height: 50%;
                text-align: center;
                display: flex;
                font-size: 16px;
                font-family: PingFangSC, PingFang SC;
                font-weight: 500;
                color: #333333;
                justify-content: center;
                align-items: center;
            }
        }





    }

    .mid-time {
        margin-top: 30px;

        .time-label {
            height: 24px;
            font-size: 17px;
            font-family: PingFangSC, PingFang SC;
            font-weight: 600;
            color: #333333;
            line-height: 24px;
            margin-bottom: 18px;
        }

        .time {
            height: 20px;
            font-size: 14px;
            font-family: PingFangSC, PingFang SC;
            font-weight: 400;
            color: #333333;
            line-height: 20px;
            margin-left: 10px;
        }

        .label-type {
            display: block;
            float: left;
            text-align: center;
            line-height: 29px;
            width: 68px;
            height: 29px;
            font-size: 12px;
            font-family: PingFangSC, PingFang SC;
            font-weight: 400;
            color: #333333;
            background: #FFFFFF;
            border-radius: 15px;
            border: 1px solid #EDEDED;
        }

        .active-type {
            background: linear-gradient(90deg, #F52A2A 0%, #C02E2E 100%);
            border-radius: 15px;
            font-size: 12px;
            font-family: PingFangSC, PingFang SC;
            font-weight: 400;
            color: #FFFFFF;


        }

        .stage {
            margin: auto;
            width: 356px;
            border: 1px solid #EEEEEE;
            display: flex;
            flex-wrap: wrap;

            .cell {
                width: 25%;
                height: 45px;
                line-height: 45px;
                text-align: center;
                font-size: 12px;
                font-family: PingFangSC, PingFang SC;
                font-weight: 400;
                color: #333333;
            }

            .stage-box {
                width: 100%;
                display: flex;
                justify-content: space-between;
                flex-wrap: wrap;

                .stage-cell {
                    width: 25%;
                    height: 45px;
                    line-height: 45px;
                    text-align: center;
                    font-size: 12px;
                    font-family: PingFangSC, PingFang SC;
                    font-weight: 400;
                    color: #333333;
                }
            }
        }
    }

    .resoure {
        width: 100%;
        height: 176px;
        overflow: auto;
        display: flex;
        flex-wrap: wrap;
        margin: 18px 0;
    }

    .resoureBox {
        width: 33%;
        height: 44px;
        font-size: 12px;
        text-align: center;
        line-height: 44px;
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
    }

    .goApply {
        font-size: 16px;
        text-align: center;
        color: #E02020;
    }

    .skip {
        margin-left: 5px;
        width: 6px;
        height: 10px;
    }

    .remark {
        width: 354px;
        height: 34px;
        font-size: 12px;
        font-family: PingFangSC, PingFang SC;
        font-weight: 400;
        color: #E02020;
        line-height: 17px;
        margin: 10px auto;
    }
}
</style>